/* OrvelleHub theme JS - vanilla, no dependencies */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- Mobile menu ---------- */
  function initMenu(root) {
    var btn = $('[data-menu-toggle]', root), nav = $('[data-nav]', root);
    if (!btn || !nav || btn.dataset.ready) return;
    btn.dataset.ready = '1';
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      nav.classList.toggle('is-open', !open);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && btn.getAttribute('aria-expanded') === 'true') { btn.click(); btn.focus(); }
    });
  }

  /* ---------- Cart count ---------- */
  function refreshCart(url) {
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = !cart.item_count;
          var icon = el.parentElement;
          if (icon) { icon.classList.remove('is-bump'); void icon.offsetWidth; icon.classList.add('is-bump'); }
        });
        return cart;
      }).catch(function () { return null; });
  }

  /* ---------- Cart notification (pop-up après ajout) ---------- */
  var cartNotice = (function () {
    var box = null, lastFocus = null;
    function el() { return box || (box = $('[data-cart-notice]')); }
    function close() {
      var b = el(); if (!b || b.hidden) return;
      b.classList.remove('is-open');
      document.documentElement.classList.remove('cnotice-lock');
      setTimeout(function () { b.hidden = true; }, 250);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    function imgUrl(u) {
      if (!u) return '';
      return u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=160';
    }
    function open(items, cart, money, addedQty) {
      var b = el(); if (!b) return false;
      var list = $('[data-cart-notice-items]', b);
      list.innerHTML = '';
      (items || []).forEach(function (it) {
        var qty = addedQty || it.quantity;
        var li = document.createElement('li');
        li.className = 'cnotice__item';
        var src = imgUrl(it.image || (it.featured_image && it.featured_image.url));
        if (src) {
          var img = document.createElement('img');
          img.src = src; img.alt = ''; img.width = 72; img.height = 72; img.loading = 'eager';
          li.appendChild(img);
        }
        var info = document.createElement('div');
        info.className = 'cnotice__info';
        var t = document.createElement('p'); t.className = 'cnotice__name'; t.textContent = it.product_title || it.title; info.appendChild(t);
        if (it.variant_title && it.variant_title !== 'Default Title') {
          var v = document.createElement('p'); v.className = 'cnotice__meta'; v.textContent = it.variant_title; info.appendChild(v);
        }
        var q = document.createElement('p'); q.className = 'cnotice__meta'; q.textContent = (b.dataset.labelQty || '{n}').replace('{n}', qty); info.appendChild(q);
        li.appendChild(info);
        var p = document.createElement('strong'); p.className = 'cnotice__price';
        p.textContent = money((it.final_price || it.price) * qty);
        li.appendChild(p);
        list.appendChild(li);
      });
      var sub = $('[data-cart-notice-subtotal]', b), cnt = $('[data-cart-notice-count]', b);
      if (cart) {
        if (sub) sub.textContent = money(cart.total_price);
        if (cnt) cnt.textContent = '(' + (b.dataset.labelItems || '{n}').replace('{n}', cart.item_count) + ')';
      } else {
        if (sub) sub.textContent = '';
        if (cnt) cnt.textContent = '';
      }
      lastFocus = document.activeElement;
      b.hidden = false;
      void b.offsetWidth;
      b.classList.add('is-open');
      if (window.matchMedia('(max-width: 749px)').matches) document.documentElement.classList.add('cnotice-lock');
      var panel = $('.cnotice__panel', b); if (panel) panel.focus({ preventScroll: true });
      return true;
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('[data-cart-notice-close]')) close();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    return { open: open, close: close };
  })();

  /* ---------- Product ---------- */
  function initProduct(root) {
    if (root.dataset.ready) return;
    var dataEl = $('[data-product-data]', root);
    if (!dataEl) return;
    root.dataset.ready = '1';

    var d = root.dataset;
    var variants = JSON.parse(dataEl.textContent).variants;
    var fmt;
    try { fmt = new Intl.NumberFormat(document.documentElement.lang || 'fr', { style: 'currency', currency: d.currency }); } catch (e) { fmt = null; }
    var money = function (c) { return fmt ? fmt.format(c / 100) : (c / 100).toFixed(2) + ' ' + d.currency; };

    var idInput = $('[data-variant-id]', root);
    var totalInput = $('[data-quantity-total]', root);
    var optionSets = $$('[data-option-set]', root);
    var offers = $$('[data-offer]', root);
    var qtyInput = $('[data-qty-input]', root);
    var atc = $('[data-add-to-cart]', root);
    var atcLabel = $('[data-atc-label]', root);
    var msg = $('[data-form-msg]', root);
    var units = $('[data-units-note]', root);
    var track = $('[data-gallery-track]', root);

    var state = {
      variant: variants.filter(function (v) { return idInput && String(v.id) === String(idInput.value); })[0] || variants[0],
      offerQty: 1, packs: 1, total: 1
    };

    function findVariant() {
      if (!optionSets.length) return variants[0];
      var chosen = optionSets.map(function (s) { var c = $('input:checked', s); return c ? c.value : null; });
      return variants.filter(function (v) {
        return v.options.every(function (val, i) { return val === chosen[i]; });
      })[0] || null;
    }
    function cap(v) { return v && v.max !== null ? Math.max(0, v.max) : Infinity; }
    function offerInput(el) { return $('[data-offer-input]', el); }

    function pickDefaultOffer() {
      var enabled = offers.filter(function (el) { return !offerInput(el).disabled; });
      var second = offers[1] && !offerInput(offers[1]).disabled ? offers[1] : null;
      var choice = second || enabled[0];
      offers.forEach(function (el) { offerInput(el).checked = (el === choice); });
    }

    function setLabel(t) { if (atcLabel) atcLabel.textContent = t; }

    function update() {
      var v = state.variant, avail = !!(v && v.available), c = cap(v);

      offers.forEach(function (el) {
        var inp = offerInput(el), q = +inp.dataset.qty, disc = +inp.dataset.discount;
        var ok = avail && c >= q;
        inp.disabled = !ok;
        el.classList.toggle('is-disabled', !ok);
        if (v) {
          var base = (v.compare > v.price ? v.compare : v.price) * q;
          var total = Math.round(v.price * q * (100 - disc) / 100);
          $('[data-offer-price]', el).textContent = money(total);
          var cmp = $('[data-offer-compare]', el);
          if (base > total) { cmp.textContent = money(base); cmp.hidden = false; } else { cmp.hidden = true; }
        }
      });
      if (offers.length) {
        var sel = offers.filter(function (el) { var i = offerInput(el); return i.checked && !i.disabled; })[0];
        if (!sel) pickDefaultOffer();
        offers.forEach(function (el) { el.classList.toggle('is-selected', offerInput(el).checked); });
        var picked = offers.filter(function (el) { return offerInput(el).checked; })[0];
        state.offerQty = picked ? +offerInput(picked).dataset.qty : 1;
      } else { state.offerQty = 1; }

      if (qtyInput) {
        var maxPacks = c === Infinity ? 99 : Math.max(1, Math.floor(c / state.offerQty));
        qtyInput.max = maxPacks;
        var p = parseInt(qtyInput.value, 10);
        if (!p || p < 1) p = 1;
        if (p > maxPacks) p = maxPacks;
        qtyInput.value = p;
        state.packs = p;
      }
      state.total = state.offerQty * state.packs;
      if (totalInput) totalInput.value = state.total;
      if (units) {
        units.hidden = !(offers.length && state.total > 1);
        units.textContent = (d.labelUnits || '').replace('{n}', state.total);
      }

      var unitEl = $('[data-unit-price]', root);
      if (unitEl) { unitEl.textContent = (v && v.unit) || ''; unitEl.hidden = !(v && v.unit); }
      var priceEl = $('[data-price-current]', root), cmpEl = $('[data-price-compare]', root);
      if (v && priceEl) {
        priceEl.textContent = money(v.price);
        if (cmpEl) { cmpEl.textContent = money(v.compare); cmpEl.hidden = !(v.compare > v.price); }
      }

      if (atc && !atc.classList.contains('is-loading')) {
        var can = avail && c >= state.total;
        atc.disabled = !can;
        setLabel(!v ? d.labelUnavailable : (!avail ? d.labelSoldout : d.labelAdd));
      }
    }

    function markSelectedCards() {
      $$('.voption', root).forEach(function (el) {
        var inp = $('input', el);
        el.classList.toggle('is-selected', !!(inp && inp.checked));
      });
    }

    function onVariantChange() {
      markSelectedCards();
      var v = findVariant();
      state.variant = v;
      if (v && idInput) {
        idInput.value = v.id;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
        try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState(null, '', u); } catch (e) {}
        if (v.media && track) {
          var slide = $('[data-media-id="' + v.media + '"]', root);
          if (slide) track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        }
      }
      update();
    }

    optionSets.forEach(function (s) { s.addEventListener('change', onVariantChange); });
    markSelectedCards();
    offers.forEach(function (el) { offerInput(el).addEventListener('change', update); });

    var minus = $('[data-qty-minus]', root), plus = $('[data-qty-plus]', root);
    if (minus) minus.addEventListener('click', function () { qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1); update(); });
    if (plus) plus.addEventListener('click', function () { qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1; update(); });
    if (qtyInput) qtyInput.addEventListener('change', update);

    if (atc) {
      atc.addEventListener('click', function () {
        if (atc.disabled || !state.variant) return;
        atc.disabled = true; atc.classList.add('is-loading'); setLabel(d.labelAdding);
        if (msg) { msg.textContent = ''; msg.className = 'form-msg'; }
        fetch(d.cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: state.variant.id, quantity: state.total }] })
        }).then(function (res) {
          return res.json().then(function (json) { return { ok: res.ok, json: json }; });
        }).then(function (r) {
          if (!r.ok) throw new Error(r.json.description || d.msgError);
          var added = r.json.items || [r.json];
          var addedQty = state.total;
          var after = $('[data-after-add]', root);
          if (after) { after.hidden = false; after.classList.remove('is-bump'); void after.offsetWidth; after.classList.add('is-bump'); }
          return refreshCart(d.cartJsUrl).then(function (cart) {
            var shown = cartNotice.open(added, cart, money, addedQty);
            if (!shown && msg) {
              msg.className = 'form-msg is-success';
              msg.textContent = d.msgAdded + ' ';
              var a = document.createElement('a');
              a.href = d.cartUrl; a.textContent = d.msgViewCart;
              msg.appendChild(a);
            }
          });
        }).catch(function (err) {
          if (msg) { msg.className = 'form-msg is-error'; msg.textContent = err && err.message ? err.message : d.msgError; }
        }).then(function () {
          atc.classList.remove('is-loading'); update();
        });
      });
    }

    /* Gallery thumbs */
    var thumbs = $$('[data-thumb]', root);
    if (track && thumbs.length) {
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          var slide = $('[data-media-id="' + t.dataset.thumb + '"]', root);
          if (slide) track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        });
      });
      var raf;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var i = Math.round(track.scrollLeft / track.clientWidth);
          thumbs.forEach(function (t, n) { t.setAttribute('aria-current', String(n === i)); });
        });
      }, { passive: true });
    }

    /* Initial state: second offer selected by default when available */
    if (offers.length) pickDefaultOffer();
    update();
  }

  /* ---------- Persistent 3h timer ---------- */
  var memStart = null;
  function initTimer(el) {
    if (el.dataset.ready) return;
    el.dataset.ready = '1';
        var days = parseFloat(el.dataset.days) || 3;
        var dur = days * 86400000, key = 'ovh_promo_start';
    function read() { try { return parseInt(window.localStorage.getItem(key), 10); } catch (e) { return memStart; } }
    function write(v) { memStart = v; try { window.localStorage.setItem(key, String(v)); } catch (e) {} }
    function start() {
      var now = Date.now(), s = read();
      if (!s || isNaN(s) || s > now || now - s >= dur) { s = now; write(s); }
      return s;
    }
      var d = $('[data-t-d]', el), h = $('[data-t-h]', el), m = $('[data-t-m]', el), sec = $('[data-t-s]', el);
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var left = dur - (Date.now() - start());
      if (left <= 0) { write(Date.now()); left = dur; }
      var t = Math.floor(left / 1000);
          d.textContent = pad(Math.floor(t / 86400)); h.textContent = pad(Math.floor((t % 86400) / 3600));
      m.textContent = pad(Math.floor((t % 3600) / 60));
      sec.textContent = pad(t % 60);
    }
    tick();
    setInterval(tick, 1000);
    document.addEventListener('visibilitychange', tick);
  }

  /* ---------- Video review: play on demand ---------- */
  function playReview(card) {
    if (card.dataset.playing) return;
    var tpl = $('[data-video-source]', card);
    var btn = $('[data-video-play]', card);
    if (!tpl) return;
    card.dataset.playing = '1';
    var node = tpl.content ? tpl.content.cloneNode(true) : null;
    if (!node) return;
    if (btn) btn.remove();
    tpl.remove();
    card.appendChild(node);
    var v = card.querySelector('video');
    if (v && v.play) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  }

  /* ---------- Carousel (true infinite loop via clones) ---------- */
  function initCarousel(el) {
    if (el.dataset.ready) return;
    el.dataset.ready = '1';
    var track = $('[data-carousel-track]', el);
    // Look for the nav buttons inside the carousel; fall back to the parent
    // container so they still bind even if the markup places them as siblings.
    var scope = el;
    if (!$('[data-carousel-prev]', el) && el.parentElement) scope = el.parentElement;
    var prev = $('[data-carousel-prev]', scope), next = $('[data-carousel-next]', scope);
    var loop = el.dataset.loop === 'true';

    function bindPlay(scope) {
      $$('[data-video-play]', scope).forEach(function (btn) {
        if (btn.dataset.playBound) return;
        btn.dataset.playBound = '1';
        btn.addEventListener('click', function () { playReview(btn.closest('[data-video-review]')); });
      });
    }

    function gapPx() {
      var style = window.getComputedStyle(track);
      return parseFloat(style.columnGap || style.gap) || 0;
    }
    function itemStep() {
      var first = track.firstElementChild;
      if (!first) return track.clientWidth * 0.8;
      return first.getBoundingClientRect().width + gapPx();
    }

    var originals = $$('.vcar__item, .carousel__item', track);
    // Enable true infinite loop only when it is worth it (more items than fit on screen)
    var canLoop = loop && originals.length > 1;

    var blockWidth = 0;
    function recalcBlock() { blockWidth = originals.length * itemStep(); }

    if (canLoop) {
      // Clone the whole set before and after, so there is always content on both sides.
      var headClones = [], tailClones = [];
      originals.forEach(function (li) {
        var a = li.cloneNode(true); a.setAttribute('aria-hidden', 'true'); a.dataset.clone = '1';
        var b = li.cloneNode(true); b.setAttribute('aria-hidden', 'true'); b.dataset.clone = '1';
        tailClones.push(a); headClones.push(b);
      });
      headClones.forEach(function (n) { track.insertBefore(n, track.firstChild); });
      tailClones.forEach(function (n) { track.appendChild(n); });

      recalcBlock();
      // Jump (no animation) to the middle (real) block.
      track.scrollLeft = blockWidth;

      // Normalize position only when the scroll has come to rest, so it never
      // fights an in-progress smooth scroll. Keeps the viewport within the middle block.
      var settleTimer;
      track.addEventListener('scroll', function () {
        clearTimeout(settleTimer);
        settleTimer = setTimeout(function () {
          var sl = track.scrollLeft;
          if (sl <= blockWidth * 0.25) {
            track.scrollLeft = sl + blockWidth;
          } else if (sl >= blockWidth * 1.75) {
            track.scrollLeft = sl - blockWidth;
          }
        }, 120);
      }, { passive: true });

      window.addEventListener('resize', function () {
        var before = blockWidth;
        recalcBlock();
        if (before) track.scrollLeft = track.scrollLeft / before * blockWidth;
      });
    }

    bindPlay(track);

    function step(dir) {
      if (canLoop) {
        // Pre-normalize to the middle block before moving, so there is always
        // room to slide one item in either direction without hitting the edge.
        var sl = track.scrollLeft;
        if (sl <= blockWidth * 0.25) track.scrollLeft = sl + blockWidth;
        else if (sl >= blockWidth * 1.75) track.scrollLeft = sl - blockWidth;
      }
      track.scrollBy({ left: dir * itemStep(), behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
  }

  /* ---------- Before / after ---------- */
  function initBA(el) {
    if (el.dataset.ready) return;
    el.dataset.ready = '1';
    var range = $('[data-ba-range]', el);
    range.addEventListener('input', function () {
      el.style.setProperty('--pos', range.value + '%');
      el.classList.add('is-touched');
    });
    range.addEventListener('pointerdown', function () { el.classList.add('is-touched'); });
  }

  /* ---------- Cart page ---------- */
  function initCartForm(form) {
    if (form.dataset.ready) return;
    form.dataset.ready = '1';
    $$('[data-cart-qty]', form).forEach(function (i) {
      i.addEventListener('change', function () { if (form.requestSubmit) form.requestSubmit(); else form.submit(); });
    });
  }

  /* ---------- Recommendations (Shopify Section Rendering API) ---------- */
  function initRecs(el) {
    if (el.dataset.ready) return;
    el.dataset.ready = '1';
    fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var src = doc.querySelector('[data-recommendations]');
      if (src && src.innerHTML.trim()) { el.innerHTML = src.innerHTML; el.hidden = false; }
    }).catch(function () {});
  }

  /* ---------- Auto-submit selects/checkboxes ---------- */
  document.addEventListener('change', function (e) {
    var t = e.target.closest('[data-auto-submit]');
    if (t && t.form) { if (t.form.requestSubmit) t.form.requestSubmit(); else t.form.submit(); }
  });

  /* ---------- Lightbox (delegated) ---------- */
  document.addEventListener('click', function (e) {
    var dlg = $('[data-lightbox]');
    if (!dlg) return;
    var z = e.target.closest('[data-zoom]');
    if (z && dlg.showModal) {
      var img = $('[data-lightbox-img]', dlg);
      img.src = z.dataset.zoom; img.alt = z.dataset.alt || '';
      dlg.showModal();
      return;
    }
    if (e.target.closest('[data-lightbox-close]') || e.target === dlg) dlg.close();
  });

  /* ---------- Product card thumbnails ---------- */
  function initCardThumbs(card) {
    if (card.dataset.thumbsReady) return;
    var thumbsWrap = $('[data-card-thumbs]', card);
    if (!thumbsWrap) return;
    card.dataset.thumbsReady = '1';
    var mainImg = card.querySelector('[data-card-main] img');
    $$('[data-card-thumb]', card).forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (mainImg) { mainImg.srcset = ''; mainImg.src = btn.dataset.cardThumb; }
        $$('[data-card-thumb]', card).forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
      });
    });
  }

  /* ---------- Reviews "show more / show less" ---------- */
  function initReviewsToggle(btn) {
    if (btn.dataset.ready) return;
    btn.dataset.ready = '1';
    var section = btn.closest('.section') || document;
    var list = $('[data-reviews]', section);
    if (!list) return;
    var initial = parseInt(list.dataset.initial || '6', 10);
    var expanded = false;
    btn.addEventListener('click', function () {
      expanded = !expanded;
      $$('[data-review-item]', list).forEach(function (item, idx) {
        item.classList.toggle('is-hidden', !expanded && idx >= initial);
      });
      btn.textContent = expanded ? btn.dataset.less : btn.dataset.more;
      if (!expanded) {
        var top = list.getBoundingClientRect().top + window.pageYOffset - 90;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }
    });
  }

  /* ---------- Auto-playing muted looping product videos ---------- */
  /* Perf: nothing heavy is fetched before the page has finished loading,
     so the main product image gets all the bandwidth first. */
  var pageLoaded = document.readyState === 'complete';
  var afterLoadQueue = [];
  function afterLoad(fn) {
    if (pageLoaded) { fn(); return; }
    afterLoadQueue.push(fn);
  }
  window.addEventListener('load', function () {
    pageLoaded = true;
    // Small delay so late analytics/checkout scripts don't compete either.
    setTimeout(function () {
      var q = afterLoadQueue; afterLoadQueue = [];
      q.forEach(function (fn) { try { fn(); } catch (e) {} });
    }, 300);
  });

  function playSafe(v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  function loadVideo(v) {
    if (v.dataset.loaded) return;
    v.dataset.loaded = '1';
    if (v.dataset.poster) v.poster = v.dataset.poster;
    if (v.dataset.src) { v.preload = 'auto'; v.src = v.dataset.src; }
  }

  function initAutoVideos(wrap) {
    if (wrap.dataset.autoReady) return;
    wrap.dataset.autoReady = '1';
    var vids = $$('video', wrap);
    if (!vids.length) return;
    vids.forEach(function (v) {
      v.muted = true; v.loop = true; v.playsInline = true;
      v.setAttribute('muted', ''); v.setAttribute('playsinline', '');
      v.removeAttribute('controls'); v.controls = false;
    });
    afterLoad(function () {
      // Posters are light: show them as soon as the page is ready.
      vids.forEach(function (v) { if (v.dataset.poster && !v.poster) v.poster = v.dataset.poster; });
      if (!('IntersectionObserver' in window)) {
        vids.forEach(function (v) { loadVideo(v); playSafe(v); });
        return;
      }
      // Download only when the video gets close to the screen.
      var loader = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { loadVideo(e.target); loader.unobserve(e.target); }
        });
      }, { rootMargin: '300px 300px' });
      // Play/pause based on visibility to save resources.
      var player = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting) { loadVideo(v); playSafe(v); }
          else if (!v.paused) { v.pause(); }
        });
      }, { threshold: 0.4 });
      vids.forEach(function (v) { loader.observe(v); player.observe(v); });
    });
  }

  /* Gallery: slides 2+ load after the page, or as soon as the shopper swipes. */
  function hydrateImg(img) {
    if (!img || !img.dataset.src) return;
    if (img.dataset.srcset) img.srcset = img.dataset.srcset;
    img.src = img.dataset.src;
    img.removeAttribute('data-src');
    img.removeAttribute('data-srcset');
  }
  function initGalleryLazy(track) {
    if (track.dataset.lazyReady) return;
    track.dataset.lazyReady = '1';
    var slides = $$('.gallery__slide', track);
    function near(i) {
      [i - 1, i, i + 1].forEach(function (n) { if (slides[n]) hydrateImg($('[data-gallery-lazy]', slides[n])); });
    }
    function current() { return Math.round(track.scrollLeft / (track.clientWidth || 1)); }
    var all = function () { slides.forEach(function (s) { hydrateImg($('[data-gallery-lazy]', s)); }); };
    // Interaction: load what is about to be seen right away.
    track.addEventListener('scroll', function () { near(current()); }, { passive: true });
    track.addEventListener('touchstart', function () { near(current()); }, { passive: true, once: true });
    var root = track.closest('[data-gallery]') || document;
    $$('[data-thumb]', root).forEach(function (t, i) {
      t.addEventListener('click', function () { near(i); });
    });
    // After load: warm up slide 2, then (when the browser is idle) slide 3
    // on mobile, or every slide on desktop. The rest loads while swiping.
    afterLoad(function () {
      near(0);
      var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 1500); };
      idle(function () {
        if (window.matchMedia && window.matchMedia('(min-width: 990px)').matches) all();
        else near(1);
      });
    });
  }

  function initAll(root) {
    root = root || document;
    initMenu(root);
    $$('[data-autoplay-videos]', root).forEach(initAutoVideos);
    $$('[data-gallery-track]', root).forEach(initGalleryLazy);
    $$('[data-product]', root).forEach(initProduct);
    $$('[data-timer]', root).forEach(initTimer);
    $$('[data-carousel]', root).forEach(initCarousel);
    $$('[data-ba]', root).forEach(initBA);
    $$('[data-cart-form]', root).forEach(initCartForm);
    $$('[data-recommendations]', root).forEach(initRecs);
    $$('[data-card]', root).forEach(initCardThumbs);
    $$('[data-reviews-toggle]', root).forEach(initReviewsToggle);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
